"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var component_library_1 = require("@kaizen/component-library");
var loading_spinner_1 = require("@kaizen/loading-spinner");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var search_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/search.icon.svg"));
var clear_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/clear.icon.svg"));
var styles_scss_1 = __importDefault(require("./styles.scss"));
var InputSearch = function (props) {
    var _a, _b;
    var id = props.id, value = props.value, onChange = props.onChange, onClear = props.onClear, classNameOverride = props.classNameOverride, placeholder = props.placeholder, _c = props.disabled, disabled = _c === void 0 ? false : _c, _d = props.reversed, reversed = _d === void 0 ? false : _d, loading = props.loading, secondary = props.secondary, genericInputProps = __rest(props, ["id", "value", "onChange", "onClear", "classNameOverride", "placeholder", "disabled", "reversed", "loading", "secondary"]);
    return (react_1["default"].createElement("div", { className: (0, classnames_1["default"])(styles_scss_1["default"].wrapper, styles_scss_1["default"].withStartIconAdornment, styles_scss_1["default"].withEndIconAdornment, styles_scss_1["default"].withSearch, (_a = {},
            _a[styles_scss_1["default"].withReversed] = reversed,
            _a[styles_scss_1["default"].withDisabled] = disabled,
            _a[styles_scss_1["default"].withSecondary] = secondary,
            _a[styles_scss_1["default"].withLoading] = loading,
            _a)) },
        react_1["default"].createElement("div", { className: styles_scss_1["default"].startIconAdornment }, loading ? (react_1["default"].createElement("div", { className: styles_scss_1["default"].loadingIcon },
            react_1["default"].createElement(loading_spinner_1.LoadingSpinner, { accessibilityLabel: "", size: "sm" }))) : (react_1["default"].createElement(component_library_1.Icon, { icon: search_icon_svg_1["default"], role: "presentation" }))),
        react_1["default"].createElement("input", __assign({ id: id, type: "search", value: value, placeholder: placeholder, disabled: disabled, onChange: onChange, className: (0, classnames_1["default"])(styles_scss_1["default"].input, styles_scss_1["default"].search, classNameOverride, (_b = {},
                _b[styles_scss_1["default"]["default"]] = !reversed,
                _b[styles_scss_1["default"].reversed] = reversed,
                _b[styles_scss_1["default"].disabled] = disabled,
                _b[styles_scss_1["default"].secondary] = secondary,
                _b)) }, genericInputProps)),
        react_1["default"].createElement("div", { className: styles_scss_1["default"].focusRing }),
        value && (react_1["default"].createElement("div", { className: styles_scss_1["default"].endIconAdornment },
            react_1["default"].createElement("button", { type: "button", className: styles_scss_1["default"].cancelButton, "aria-label": "clear", onClick: onClear },
                react_1["default"].createElement(component_library_1.Icon, { icon: clear_icon_svg_1["default"], role: "presentation" }))))));
};
exports["default"] = InputSearch;
//# sourceMappingURL=InputSearch.js.map